"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Companies = void 0;
var Companies;
(function (Companies) {
    Companies["SIRMAN"] = "sirman";
    Companies["FELSINEA"] = "felsinea";
})(Companies || (exports.Companies = Companies = {}));
//# sourceMappingURL=enum.js.map